import type { Reducer } from 'redux';

import { ACTIONS } from '../actions/question-widget-height';

interface InitialState {
  data?: Record<string, string>;
}

type WidgetOriginalHeightReducer = Reducer<InitialState>;

const initialState: InitialState = {};

const reducer: WidgetOriginalHeightReducer = (state = initialState, action) => {
  const { type } = action;

  if (type === ACTIONS.SET_QUESTION_WIDGET_HEIGHT) {
    return {
      ...state,
      data: action.payload.widgetsHeight,
    };
  }

  if (type === ACTIONS.CLEAR_QUESTION_WIDGET_HEIGHT) {
    return initialState;
  }

  return state;
};

export default reducer;
